import React, { useState } from 'react';

const Info = ({ imageUrl }) => {
    const [showInfo, setShowInfo] = useState(false);

    const handleToggle = () => {
        setShowInfo((prev) => !prev);
    };

    return (
        <div className="info-container">
            <p className="info-button" onClick={handleToggle} aria-expanded={showInfo} aria-controls="info-content">
                info
            </p>
            <div

                className="info-content"
                style={{ display: showInfo ? 'flex' : 'none' }}
            >
                <img src={imageUrl} alt="handwriting background" />
                <p>All images © Timothée Lambrecq, available for licensing, send me an <a href="mailto:timothee.lambrecq@gmail.com">email</a>. site by <a href="https://ff87c3.eu" target="_blank">ff87c3.eu</a></p>

            </div>
        </div>
    );
};

export default Info